"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThemeProvider = void 0;

var react_1 = require("@emotion/react");

var react_2 = __importDefault(require("react"));

var theme_variables_1 = require("./theme-variables");

var theme_styles_1 = require("./theme-styles");

var theme_variables_2 = require("./theme-variables");

var breakpoints_1 = require("./breakpoints");

var theme_styles_2 = require("./theme-styles");

function ThemeProvider(_a) {
  var children = _a.children,
      // @ts-ignore
  _b = _a.variableDefs,
      // @ts-ignore
  variableDefs = _b === void 0 ? theme_variables_2.defaultThemeVariables : _b,
      resposiveVariableDefs = _a.resposiveVariableDefs,
      // @ts-ignore
  _c = _a.styleDefs,
      // @ts-ignore
  styleDefs = _c === void 0 ? theme_styles_2.defaultThemeStyles : _c,
      _d = _a.breakpointDefs,
      breakpointDefs = _d === void 0 ? breakpoints_1.defaultBreakpoints : _d,
      bpThresholdType = _a.bpThresholdType;
  var breakpoints = (0, breakpoints_1.createBreakpoints)(breakpointDefs, bpThresholdType);

  var variableDefinitions = __spreadArray([(0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      :root {\n        ", ";\n      }\n    "], ["\n      :root {\n        ", ";\n      }\n    "])), (0, theme_variables_1.createVariableDefinitions)(variableDefs))], __read(Object.entries(resposiveVariableDefs !== null && resposiveVariableDefs !== void 0 ? resposiveVariableDefs : {}).filter(function (_a) {
    var _b = __read(_a, 2),
        value = _b[1];

    return value;
  }).map(function (_a) {
    var _b = __read(_a, 2),
        key = _b[0],
        value = _b[1];

    return (0, react_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n          @media ", " {\n            :root {\n              ", ";\n            }\n          }\n        "], ["\n          @media ", " {\n            :root {\n              ", ";\n            }\n          }\n        "])), breakpoints[key], (0, theme_variables_1.createVariableDefinitions)(value));
  })), false);

  var variables = (0, theme_variables_1.createVariableReferences)(Object.values(resposiveVariableDefs !== null && resposiveVariableDefs !== void 0 ? resposiveVariableDefs : {}).filter(function (value) {
    return value;
  }).reduce(function (prev, current) {
    return (0, theme_variables_1.extendVariables)(current, prev);
  }, variableDefs)); // @ts-ignore

  var styles = (0, theme_styles_1.createStyles)(styleDefs, variables);
  return react_2.default.createElement(react_1.ThemeProvider, {
    theme: {
      variables: variables,
      styles: styles,
      breakpoints: breakpoints
    }
  }, react_2.default.createElement(react_1.Global, {
    styles: variableDefinitions
  }), children);
}

exports.ThemeProvider = ThemeProvider;
var templateObject_1, templateObject_2;